import React, { useState, useEffect } from 'react';
import axiosConfig from "../axiosConfig";
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Header from '../Header/Header';
import MainMenu from '../MainMenu/MainMenu';
import Cookies from 'universal-cookie';
import LiveMap from "./LiveMap";



const LiveChannels = () => {
    const cookies = new Cookies();

    const [regionM, setRegionM] = useState([]);
    const [region, setRegion] = useState("");
    const [count, setCount] = useState(0);
    const [gender, setGender] = useState("");
    const [economic, setEconomic] = useState("");
    const [socio] = useState("");
    const [userType] = useState("STB");
    const [age1, setAge1] = useState(1);
    const [age2, setAge2] = useState(100);
    const [filterType, setFilterType] = useState("");
    const [activeUserCSV, setActiveUserCSV] = useState({});
    const [points, setpoints] = useState([]);
    const [sectionChartData, setSectionChartData] = useState({ labels: [], datasets: [] });
    const [genderChartData, setGenderChartData] = useState({ labels: [], datasets: [] });
    const [regionChartData, setRegionChartData] = useState({ labels: [], datasets: [] });
    const [ageChartData, setAgeChartData] = useState({ labels: [], datasets: [] });
    const Updater = () => {
        setCount(count + 1);
    }
    useEffect(() => {
        axiosConfig.get("/Regions").then(rsp => {
            console.log(rsp.data.Regions);
            //value : ['khulna', 'dhaka', 'rangpur', 'chattogram', 'rajshahi', 'dhaka Rural', 'mymensingh', 'sylhet', 'barishal']
            setRegionM(rsp.data.Regions);
            Updater();
        }).catch(err => {
            //console.log(err);
        });
    }, []);
    

    function pad(n) {
        return n < 10 ? '0' + n : n
    }
    var today = new Date(),
        datetime = today.getFullYear() + '-' + pad((today.getMonth() + 1)) + '-' + pad(today.getDate()) + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();


    function exportToCsv(filename, rows) {
        var processRow = function (row) {
            var finalVal = '';
            for (var j = 0; j < row.length; j++) {
                var innerValue = row[j] === null ? '' : row[j].toString();
                if (row[j] instanceof Date) {
                    innerValue = row[j].toLocaleString();
                };
                var result = innerValue.replace(/"/g, '""');
                if (result.search(/("|,|\n)/g) >= 0)
                    result = '"' + result + '"';
                if (j > 0)
                    finalVal += ',';
                finalVal += result;
            }
            return finalVal + '\n';
        };
        var csvFile = '';
        for (var i = 0; i < rows.length; i++) {
            csvFile += processRow(rows[i]);
        }
        var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    var getCSV = (scsv) => {
        if (userType == "") {
            exportToCsv("Active_User(_All-User-Type_" + modify_date(datetime) + ").csv", scsv)
        } else if (userType == "OTT") {
            exportToCsv("Active_User(" + userType + "_" + modify_date(datetime) + ").csv", scsv)
        } else if (userType == "STB") {
            exportToCsv("Active_User(" + userType + "_" + (region ? region : "All_Region") + "_" + (gender ? gender == "m" ? "Male" : "Female" : "All-Gender") + "_" + (economic ? (economic === "a" ? "SEC A" : economic === "b" ? "SEC B" : economic === "c" ? "SEC C" : economic === "d" ? "SEC D" : "All SEC") : "All SEC") + "_" + (socio ? socio == "u" ? "Urban" : "Rural" : "Urban&Rural") + "_Age-" + age1 + " - " + age2 + "_" + modify_date(datetime) + ").csv", scsv)
        }

        //exportToCsv("Acive-User.csv", scsv)
    }

    const LivechannelDownloadfunc = () => {


        //console.log(liveChannelData.labels[0]);
        if (userType == "") {
            var csv = [["Audience/User Type-", "All_User_type"], ["Time-", modify_date(datetime)], ["", ""], ["Channel", "Active_Users"]];
        } else if (userType == "OTT") {
            var csv = [["Audience/User Type-", userType], ["Time-", modify_date(datetime)], ["", ""], ["Channel", "Active_Users"]];
        } else if (userType == "STB") {
            var csv = [["Audience/User Type-", userType], ["Region-", (region ? region : "All_Region")], ["Gender-", (gender ? gender == "m" ? "Male" : "Female" : "All-Gender")], ["SEC-", (economic ? (economic === "a" ? "SEC A" : economic === "b" ? "SEC B" : economic === "c" ? "SEC C" : economic === "d" ? "SEC D" : "All SEC") : "All SEC")], ["Socio-", (socio ? socio == "u" ? "Urban" : "Rural" : "Urban&Rural")], ["Age Range-", age1 + " to " + age2], ["Time-", modify_date(datetime)], ["", ""], ["Channel", "Active_Users"]];
        }

        //download input
        axiosConfig.post("/entry/download", { operation_type: "download", affected: "live_channels", value: {input: csv, value: activeUserCSV} }).then((rsp) => {
            
            //var csv = [["Channel", "Active Users"]];
            var sampleLive = activeUserCSV;
            for (var i = 0; i < sampleLive.labels.length; i++) {
                csv.push([sampleLive.labels[i], sampleLive.values[i]]);
            }
            //console.log(csv);
            getCSV(csv);
        }, (err) => {
            //console.log(err);
            alert("Unable to download");
        });

    }

    useEffect(() => {
        var data = {
            region: (region == "" ? regionM : [region]),
            userType: userType,
            gender: gender,
            sec: (economic != "") ? ["SEC " + (economic ? economic.toUpperCase() : "")] : ["SEC A", "SEC B", "SEC C", "SEC D"],
            //socio: socio,
            age1: age1,
            age2: age2
        };

        //console.log(data);

        axiosConfig.post("/livechannel/activechannellistgraphfast", data).then(rsp => {
            //console.log(rsp.data);
            setpoints(rsp.data.points);
            console.log(rsp.data.points);
            setActiveUserCSV(() => ({
                labels: rsp.data.channels, values: rsp.data.user_count
            }));
        }).catch(err => {

        });

    }, [count, region, gender, economic, age1, age2, regionM]);

    useEffect(() => {
        if (filterType !== "section") {
            return;
        }

        axiosConfig.get("/latest-requests/1").then(rsp => {
            var rows = (rsp && rsp.data && rsp.data.data) ? rsp.data.data : [];
            var channels = Array.from(new Set(rows.map(r => r.channel)));
            var sections = ["SEC A", "SEC B", "SEC C", "SEC D"];
            var totals = {};

            rows.forEach(r => {
                var key = r.channel + "||" + r.sec;
                var val = parseInt(r.total || 0);
                totals[key] = (totals[key] || 0) + val;
            });

            var colors = ["#4472c4", "#ed7d31", "	#a5a5a5", "	#ffc000"];
            var datasets = sections.map((sec, idx) => {
                return {
                    label: sec,
                    data: channels.map(ch => totals[ch + "||" + sec] || 0),
                    backgroundColor: colors[idx % colors.length],
                    stack: "section"
                };
            });

            setSectionChartData({ labels: channels, datasets: datasets });
        }).catch(err => {
            setSectionChartData({ labels: [], datasets: [] });
        });
    }, [count, filterType]);

    useEffect(() => {
        if (filterType !== "gender") {
            return;
        }

        axiosConfig.get("/latest-requests/2").then(rsp => {
            var rows = (rsp && rsp.data && rsp.data.data) ? rsp.data.data : [];
            var channels = Array.from(new Set(rows.map(r => r.channel)));
            var genders = ["Male", "Female"];
            var totals = {};

            var normalizeGender = (val) => {
                if (!val) return "";
                var v = ("" + val).toLowerCase();
                if (v === "m" || v === "male") return "Male";
                if (v === "f" || v === "female") return "Female";
                return val;
            };

            rows.forEach(r => {
                var g = normalizeGender(r.gender || r.sex || r.Gender || r.Sex);
                var key = r.channel + "||" + g;
                var val = parseInt(r.total || 0);
                totals[key] = (totals[key] || 0) + val;
            });

            var colors = ["#4472c4", "#ed7d31", "	#a5a5a5", "	#ffc000"];
            var datasets = genders.map((g, idx) => {
                return {
                    label: g,
                    data: channels.map(ch => totals[ch + "||" + g] || 0),
                    backgroundColor: colors[idx % colors.length],
                    stack: "gender"
                };
            });

            setGenderChartData({ labels: channels, datasets: datasets });
        }).catch(err => {
            setGenderChartData({ labels: [], datasets: [] });
        });
    }, [count, filterType]);

    useEffect(() => {
        if (filterType !== "region") {
            return;
        }

        axiosConfig.get("/latest-requests/3").then(rsp => {
            var rows = (rsp && rsp.data && rsp.data.data) ? rsp.data.data : [];
            var channels = Array.from(new Set(rows.map(r => r.channel)));
            var regions = Array.from(new Set(rows.map(r => r.region || r.Region || r.REGION))).filter(Boolean);
            var totals = {};

            rows.forEach(r => {
                var reg = r.region || r.Region || r.REGION || "";
                var key = r.channel + "||" + reg;
                var val = parseInt(r.total || 0);
                totals[key] = (totals[key] || 0) + val;
            });

            var colors = ["#4472c4", "#ed7d31", "	#a5a5a5", "	#ffc000", "#4472C4", "#ED7D31", "#70AD47", "#7030A0", "#A5A5A5"];
            var datasets = regions.map((reg, idx) => {
                return {
                    label: reg,
                    data: channels.map(ch => totals[ch + "||" + reg] || 0),
                    backgroundColor: colors[idx % colors.length],
                    stack: "region"
                };
            });

            setRegionChartData({ labels: channels, datasets: datasets });
        }).catch(err => {
            setRegionChartData({ labels: [], datasets: [] });
        });
    }, [count, filterType]);

    useEffect(() => {
        if (filterType !== "age") {
            return;
        }

        axiosConfig.get("/latest-requests/4").then(rsp => {
            var rows = (rsp && rsp.data && rsp.data.data) ? rsp.data.data : [];
            var channels = Array.from(new Set(rows.map(r => r.channel)));
            var ageGroups = [
                "Age Group A = 0-14",
                "Age Group B = 15-24",
                "Age Group C = 25-34",
                "Age Group D = 35-44",
                "Age Group E = 45 & Above"
            ];
            var totals = {};

            var normalizeAgeGroup = (val) => {
                if (!val) return "";
                var v = ("" + val).toLowerCase();
                if (v === "a" || v.includes("0-14")) return "Age Group A = 0-14";
                if (v === "b" || v.includes("15-24")) return "Age Group B = 15-24";
                if (v === "c" || v.includes("25-34")) return "Age Group C = 25-34";
                if (v === "d" || v.includes("35-44")) return "Age Group D = 35-44";
                if (v === "e" || v.includes("45")) return "Age Group E = 45 & Above";
                return val;
            };

            rows.forEach(r => {
                var g = normalizeAgeGroup(r.age_group || r.ageGroup || r.age || r.AgeGroup || r.AGE_GROUP);
                var key = r.channel + "||" + g;
                var val = parseInt(r.total || 0);
                totals[key] = (totals[key] || 0) + val;
            });

            var colors = ["#4472c4", "#ed7d31", "	#a5a5a5", "	#ffc000", "#BF9000"];
            var datasets = ageGroups.map((g, idx) => {
                return {
                    label: g,
                    data: channels.map(ch => totals[ch + "||" + g] || 0),
                    backgroundColor: colors[idx % colors.length],
                    stack: "age"
                };
            });

            setAgeChartData({ labels: channels, datasets: datasets });
        }).catch(err => {
            setAgeChartData({ labels: [], datasets: [] });
        });
    }, [count, filterType]);


    const modify_date = (date) => {

        return new Date(date).toLocaleString(undefined, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }


    return (
        <div><Header title="Live Channels (V2)" />
            <MainMenu menu="livechannels" />

            {/* <div class="app-content content"> */}
            <div class=" content">
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >

                    <div class="content-body">

                        <div class="row">
                            <div class="col-md-3">
                                <select class="custom-select d-block w-100" value={filterType} onChange={(e) => { setFilterType(e.target.value) }}>
                                    <option value="">Select Filter</option>
                                    <option value="section">Section</option>
                                    <option value="gender">Gender</option>
                                    <option value="region">Region</option>
                                    <option value="age">Age</option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <button onClick={Updater} class="btn btn-danger">View</button>
                            </div>
                        </div>

                        {(filterType === "section" || filterType === "gender" || filterType === "region" || filterType === "age") &&
                            <div class="row justify-content-md-center mt-2">
                                <div class="col">
                                    <div class="card">
                                        <div class="card-header">
                                            <div class="row">
                                                <div class="col-11 h2 card-title font-weight-bold">
                                                    {filterType === "gender" ? "Channel vs Gender" : filterType === "region" ? "Channel vs Region" : filterType === "age" ? "Channel vs Age" : "Channel vs Section"}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-content collapse show" style={{ height: "30em" }}>
                                            <Bar
                                                data={filterType === "gender" ? genderChartData : filterType === "region" ? regionChartData : filterType === "age" ? ageChartData : sectionChartData}
                                                plugins={[ChartDataLabels]}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: false,
                                                    plugins: {
                                                        legend: {
                                                            position: 'bottom'
                                                        },
                                                        datalabels: {
                                                            color: '#000',
                                                            anchor: 'center',
                                                            align: 'center',
                                                            formatter: (value) => value ? value : ''
                                                        }
                                                    },
                                                    scales: {
                                                        x: { stacked: true },
                                                        y: { stacked: true, beginAtZero: true }
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {(cookies.get('_role') === "admin" || cookies.get('_role') === "operator") &&
                            <div class="row justify-content-md-center">
                                <div class="col">
                                    {/* <PostGraph title="Active Users" text="Active Channels" url="reach/percent" label="Active Users" color="blue" credentials={credential} /> */}
                                    <div class="card">
                                        <div class="card-header">
                                            <div class="row"><div class="col-11 h2 card-title font-weight-bold">Active User</div><div class="row col card-title align-items-right"><button onClick={LivechannelDownloadfunc} class="btn btn-sm btn-secondary">Download CSV</button></div></div>

                                        </div>
                                        <div class="card-content collapse show" style={{ height: "15em !important" }}>


                                            <LiveMap points={points} />


                                        </div>
                                    </div>
                                </div>
                            </div>
                        }




                    </div>

                </div>
            </div>
        </div>

    )
}
export default LiveChannels;
